import styled from "styled-components";

import Box from "../../../layout/boxes/Box";

import {
	StyledAccordionContentProps,
	StyledAccordionContentWrapperProps,
} from "./AccordionContent.types";

export const StyledAccordionContent = styled(
	({ isOpen, contentHeight, ...props }: StyledAccordionContentProps) => (
		<Box
			position="relative"
			maxHeight={isOpen ? `${contentHeight}px` : 0}
			overflow="hidden"
			{...props}
		/>
	)
)`
	opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
	transition: opacity 300ms ease-in-out, max-height 300ms ease-in-out;
`;

export const StyledAccordionContentWrapper = styled.div<StyledAccordionContentWrapperProps>`
	display: block;
	padding: ${({ theme }) => `0 calc(2*${theme.space.lg}) ${theme.space.lg} 0`};
`;
